import { createAction } from 'redux-actions';

// Centralize actions across the entire app
// not just individually to a reducer
export namespace AppActions {
  export enum Type {
    USER_LOGIN = 'USER_LOGIN',
    USER_LOGOUT = 'USER_LOGOUT'
  }

  export const userLogin = createAction<{payload: string}>(Type.USER_LOGIN);
  export const userLogout = createAction<{payload: any}>(Type.USER_LOGOUT);
}

export type AppActions = Omit<typeof AppActions, 'Type'>;
